import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export async function uploadTrackImage({ file, track }) {
    const rawExt = (file.name.split('.').pop() || 'jpg').toLowerCase();
    const ext = rawExt.replace(/[^a-z0-9]/g, '') || 'jpg';
    const rand = Math.random().toString(16).slice(2, 8);
    const path = `${track}/${Date.now()}-${rand}.${ext}`;
    const fileRef = ref(storage, path);
    await uploadBytes(fileRef, file, {
        cacheControl: "public, max-age=31536000, immutable",
        contentType: file.type || undefined,
    });
    return getDownloadURL(fileRef);
}
